module.exports = __webpack_public_path__ + "static/media/austin-distel-wD1LRb9OeEo-unsplash.b7739113.jpg";